import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';
import { controlNameBinding } from '@angular/forms/src/directives/reactive_directives/form_control_name';

@Directive({
  selector: '[appThreeDigitsDecimalMax10]',
  providers: [{provide: NG_VALIDATORS, useExisting: ThreeDigitsDecimalMax10ValidatorDirective, multi: true}]
})
// It should accept 777, 888, 999, and numbers under 10 with 2-digit decimals
export class ThreeDigitsDecimalMax10ValidatorDirective implements Validator {
  @Input('appThreeDigitsDecimalMax10') appThreeDigitsDecimalMax10: string;

  validate(control: AbstractControl): {[key: string]: any} | null {
    if (!this.appThreeDigitsDecimalMax10) {
      return null;
    }
    if (control.value == null || isNaN(control.value)) {
      return { nan: true, valid: false };
    }
    if (control.value >= 0 && control.value < 10) {
      return null;
    }
    if (['777', '888', '999', 777, 888, 999].includes(control.value)) {
      return null;
    }
    else {
      return { outofrange: true, valid: false };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/validators/three-digits-decimal-max-10.validator.ts